import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { components } from './generated/selfCare';
import { URLS } from '@/constants/api';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { apiSelfCareFetcher } from '../fetcher';
export type PublicUpsellServicesPriceCalculatorResponse = components['schemas']['UpsellServiceConfiguration'][] | undefined;
export type PublicUpsellServicesPriceCalculatorParams = {
  purchasedItemPrice: number;
  purchasedItemCategory: components['schemas']['UpsellServicePurchasedItemCategoryEnum'];
  duration?: number;
};
export function usePublicUpsellServicesPriceCalculator(params, options) {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = QUERY_KEYS.publicUpsellServicesPriceCalculator(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = async () => {
      const res = await apiSelfCareFetcher(URLS.publicUpsellServicesPriceCalculator, {
        searchParams: {
          purchasedItemPrice: params.purchasedItemPrice,
          purchasedItemCategory: params.purchasedItemCategory,
          duration: params.duration
        }
      });
      if (!res.json) {
        throw new Error("No data returned");
      }
      return res.json;
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      placeholderData: keepPreviousData,
      ...options
    };
    $[4] = options;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
}